import { RootState } from "core-integration/src/store";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import { Button } from "plos/src/components/buttons/Button";
import HorizontalDivider from "plos/src/components/HorizontalDivider";
import useIsMobile from "plos/src/hooks/useIsMobile";
import { contentMain } from "plos/src/layouts";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useAdobeContext } from "../../../../contexts/AdobeContext";
import adobeXFpl from "../../../../img/FPLxAdobeModal.png";
import adobeXFplMobile from "../../../../img/FPLxAdobeModalMobile.png";
import { ControlArrowRight } from "../../../icons/Arrows";
import styles from "./AdobeTeamSavedContent.module.css";

interface AdobeTeamSavedContentProps {
  handleCreateCrest: (img: Blob, prompt: string) => Promise<void>;
  closeDialog: () => void;
}

const AdobeTeamSavedContent = ({
  handleCreateCrest,
  closeDialog,
}: AdobeTeamSavedContentProps) => {
  const { t } = useTranslation("pickTeam");

  const player = useSelector(getPlayerData) as ILoggedInPlayer; // enforced by EntryRoute
  const entry = useSelector((state: RootState) =>
    getEntry(state, player.entry),
  );

  const { embed } = useAdobeContext();
  const isMobile = useIsMobile();
  const adobeImage = isMobile ? adobeXFplMobile : adobeXFpl;

  return (
    <>
      <div className={styles.adobeImageContainer}>
        <img
          src={adobeImage}
          className={styles.adobeFplImage}
          alt={t("adobeImageAlt", "Adobe x FPL Badge Creator")!}
        />
      </div>
      <div className={contentMain}>
        <h3>{t("yourTeamYourBadge", "Your team, your badge.")}</h3>
        <p>
          {t(
            "adobeTeamSavedContent",
            "Create your team badge to enter the Adobe Express Badge League to compete for a VIP Premier League Experience.",
          )}
        </p>
        <Button
          onPress={() => {
            closeDialog();
            embed.createImage({
              badgeHolder: Boolean(
                entry.club_badge_src && entry.club_badge_src !== "Pending",
              ),
              onImageCreate: async (img, prompt) => {
                await handleCreateCrest(img, prompt);
              },
            });
          }}
          size="small"
        >
          {t("generateTeamBade", "Generate Team Badge")}
          <ControlArrowRight />
        </Button>
        <HorizontalDivider />
        <p>{t("teamSavedAlt", "Your Team has been Saved")}</p>
      </div>
    </>
  );
};

export default AdobeTeamSavedContent;
